function BrandedImage({ src, alt, imageClassName = '', wrapperClassName = '' }) {
  return (
    <div className={`branded-image-wrap ${wrapperClassName}`.trim()}>
      <img src={src} alt={alt} className={imageClassName} />
    </div>
  );
}

export default BrandedImage;